module.exports = __webpack_public_path__ + "34736292/img/cadBim.e369a02a.png";